import * as ActionTypes from '../constants/actiontypes/user';
import * as AuthActionTypes from '../constants/actiontypes/auth';
import * as DeathDeclarationActionTypes from '../constants/actiontypes/facilita/deathDeclaration';
import *  as axios from 'axios';
import * as urls from '../constants/webapi/user';
import * as serviceUrls from '../constants/webapi/services';
import { getAuthenticationUrl } from '../constants/webapi/auth';
import { FileTypes } from '../constants/utils/fileTypes';
import * as R from 'ramda';

export function fetchUserByEmail(phoneNumber) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USER_REQUEST, phoneNumber: phoneNumber });
		return axios.get(urls.userByPhoneNumberUrl(phoneNumber))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USER_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function fetchUserById(id) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USER_REQUEST, id: id });
		return axios.get(urls.userByIdUrl(id))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USER_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}


export function updateUser(user) {
	if (R.isNil(user.isEnabled)) {
		user.isEnabled = true;
	}
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USER_REQUEST, user: user.id });
		return axios.put(urls.userByIdUrl(user.id), user)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USER_SUCCESS,
					data: response.data,
					user: user
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateUserSecurity(user) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USER_SECURITY_REQUEST, user: user.id });
		return axios.put(urls.userSecurityByIdUrl(user.id), user)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USER_SECURITY_SUCCESS,
					data: response.data,
					user: user
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USER_SECURITY_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function changePhoneNumber(user) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.CHANGE_PHONENUMBER_REQUEST, user: user.id });
		return axios.post(urls.changePhoneNumberUrl(user.id), user)
			.then((response) => {
				dispatch({
					type: ActionTypes.CHANGE_PHONENUMBER_SUCCESS,
					data: response.data,
					user: user
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.CHANGE_PHONENUMBER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function deleteUser(user) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_USER_REQUEST, user: user });
		return axios.delete(urls.userByIdUrl(user.id))
			.then((response) => {
				window.location = getAuthenticationUrl();
				dispatch({
					type: ActionTypes.DELETE_USER_SUCCESS,
					data: response.data,
					user: user
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_USER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateOnBoardingStep(step) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_ONBOARDINGSTEP_REQUEST, step: step });

		return axios.put(urls.updateOnBoardingStepUrl(step))
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_ONBOARDINGSTEP_SUCCESS,
					data: response.data,
					step: step
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_REPRESENTATIVE_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function addUserAddress(address) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_USER_ADDRESS_REQUEST, user: address.user.id });
		return axios.post(urls.userAddressByIdUrl(address.user.id), address)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_USER_ADDRESS_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_USER_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateAddress(address) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USER_ADDRESS_REQUEST, user: address.user.id, address: address.id });
		return axios.put(urls.userAddressByIdWithIdUrl(address.user.id, address.id), address)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USER_ADDRESS_SUCCESS,
					data: response.data,
					address: address
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USER_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserAddress(userId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USER_ADDRESS_REQUEST, user: userId });
		return axios.get(urls.userAddressByIdUrl(userId))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USER_ADDRESS_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USER_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserRepresentatives() {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_REPRESENTATIVES_REQUEST });
		return axios.get(urls.userRepresentativesUrl())
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_REPRESENTATIVES_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_REPRESENTATIVES_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function addUserRepresentative(representative) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_REPRESENTATIVE_REQUEST, representative: representative });
		return axios.post(urls.userRepresentativesUrl(), representative)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_REPRESENTATIVE_SUCCESS,
					data: response.data,
					tmpRef: representative.tmpRef
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_REPRESENTATIVE_FAILURE,
					response: error.response
				});
				throw error.response.data;
			});
	};
}

export function updateRepresentative(representative) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_REPRESENTATIVE_REQUEST, representative: representative });
		return axios.put(urls.userRepresentativeByIdUrl(representative.id), representative)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_REPRESENTATIVE_SUCCESS,
					data: response.data,
					referent: representative
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_REPRESENTATIVE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function deleteRepresentative(representative) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_REPRESENTATIVE_REQUEST, representative: representative });
		return axios.delete(urls.userRepresentativeByIdUrl(representative.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.DELETE_REPRESENTATIVE_SUCCESS,
					data: response.data,
					referent: representative
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_REPRESENTATIVE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserRepresentativeAddress(referent) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_REPRESENTATIVES_ADDRESS_REQUEST, referent: referent });
		return axios.get(urls.userRepresentativeAdressByIdUrl(referent.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_REPRESENTATIVES_ADDRESS_SUCCESS,
					data: response.data,
					referent: referent
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_REPRESENTATIVES_ADDRESS_FAILURE,
					response: error.response,
					referent: referent
				});
				throw error.statusText;
			});
	};
}


export function addUserRepresentativeAddress(id, address) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_REPRESENTATIVE_ADDRESS_REQUEST, referentId: id });
		return axios.post(urls.userRepresentativeAdressByIdUrl(id), address)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_REPRESENTATIVE_ADDRESS_SUCCESS,
					data: response.data,
					referentId: id,
					address: address
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_REPRESENTATIVE_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateUserRepresentativeAddress(id, address) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_REPRESENTATIVE_ADDRESS_REQUEST, id: id });
		return axios.put(urls.userRepresentativeAdressIdByIdUrl(id, address.id), address)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_REPRESENTATIVE_ADDRESS_SUCCESS,
					data: response.data,
					referentId: id,
					address: address
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_REPRESENTATIVE_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

//#region Services
export function deleteService(user, service) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_USER_SERVICE_REQUEST, service: service.id });
		return axios.delete(urls.userServiceByIdUrl(user.id, service.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.DELETE_USER_SERVICE_SUCCESS,
					data: response.data,
					service: service
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_USER_SERVICE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserServices(user) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USER_SERVICES_REQUEST, user: user.id });
		return axios.get(urls.userServicesUrl(user.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USER_SERVICES_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USER_SERVICES_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserServiceData(userId, serviceType) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_REQUEST, user: userId });
		return axios.get(urls.userServiceDataUrl(userId, serviceType))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserServiceDataDetails(serviceId) {

	return new Promise((resolve, reject) => {

		return axios.get(serviceUrls.getServiceDetailByIdUrl(serviceId))
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				reject(error.response);

				throw error.statusText;
			});
	});
}


export function addUserService(user, service) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_USER_SERVICE_REQUEST, user: user.id });
		return axios.post(urls.userServicesUrl(user.id), service)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_USER_SERVICE_SUCCESS,
					data: response.data,
					service: service
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_USER_SERVICE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function addUserServicesBatch(user, services) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_SERVICES_BATCH_REQUEST, user: user.id });
		return axios.post(urls.userServicesBatchUrl(user.id), services)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_SERVICES_BATCH_SUCCESS,
					data: response.data,
					services: services
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_SERVICES_BATCH_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateUserService(user, service) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USER_SERVICE_REQUEST, user: user.id });
		return axios.put(urls.userServiceByIdUrl(user.id, service.id), service)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USER_SERVICE_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USER_SERVICE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}
//#endregion

//#region Documents
// export function uploadDocument(userId, fileType, document, description) {
//     let data = new FormData();
//     const config = {
//         headers: { 'content-type': 'multipart/form-data', 'user-description': description },
//         credential: 'include'
//     }
// 	data.append("file", document, document.name);

//     return (dispatch) => {
//         dispatch({ type: ActionTypes.UPLOAD_DOCUMENT_REQUEST, documentName: document.name, fileType: fileType });
//         return axios.post(urls.userDocumentUrl(userId, fileType), data, config)
//             .then((response) => {
//                 dispatch({
//                     type: ActionTypes.UPLOAD_DOCUMENT_SUCCESS,
//                     data: response.data,
// 					documentName: document.name,
// 					fileType: fileType,
// 					description: description
//                 });
//                 return response;
//             })
//             .catch((error) => {
//                 if(error.response !== undefined && error.response.status === 401){
//                     window.location = getAuthenticationUrl();
//                     return;
//                 }
//                 dispatch({
//                     type: ActionTypes.UPLOAD_DOCUMENT_FAILURE,
// 					error: error.response,
// 					documentName: document.name,
// 					fileType: fileType
//                 });
//                 throw error;
//             })
//     };
// }

export function updateFileDescription(userId, document, description, filePath){
	return (dispatch) => {
		return axios.patch(urls.userDocumentUrl(userId, document.fileName, filePath), {fileName: document.fileName, fileType: document.fileType, description: description})
		.then((response) => {
			dispatch({
				type: ActionTypes.EDIT_DOCUMENT_SUCCESS,
				file: response.data
			});
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
	}
}


export function uploadDocument(userId, fileType, document, description, filePath) {
	let data = new FormData();
	const config = {
		headers: { 'content-type': 'multipart/form-data' },
		credential: 'include'
	};
	if(!R.isNil(document)){
		data.append("file", document, document.name);
	}else{
		document = {name: null}
	}
	
	data.append("fileDescription", description);
	if(!R.isNil(filePath)){
		data.append("filePath", filePath);
	}

	return (dispatch) => {
		dispatch({ type: ActionTypes.UPLOAD_DOCUMENT_REQUEST, documentName: document.name, fileType: fileType });
		return axios.post(urls.userDocumentUrl(userId, fileType), data, config)
			.then((response) => {
				const file = { fileName: document.name, fileType: fileType, description: description };
				dispatch({
					type: ActionTypes.UPLOAD_DOCUMENT_SUCCESS,
					file: file
				});
				return file;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPLOAD_DOCUMENT_FAILURE,
					error: error.response,
					documentName: document.name,
					fileType: fileType
				});
				throw error;
			});
	};
}

export function getDocuments(user, shouldDispatch, path) {
	if(R.isNil(shouldDispatch)){
		shouldDispatch = true;
	}
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_DOCUMENTS_REQUEST, user: user.id });
		return axios.get(urls.userDocumentsUrl(user.id, path))
			.then((response) => {
				if(shouldDispatch){
					dispatch({
						type: ActionTypes.FETCH_DOCUMENTS_SUCCESS,
						data: response.data,
					});
				}
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_DOCUMENTS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getDocumentsProfile(user) {
	return new Promise((resolve, reject) => {
		axios.get(urls.userDocumentsUrl(user.id))
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
			});
	});
}

export function downloadDocument(userId, fileType, path) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DOWNLOAD_DOCUMENT_REQUEST, fileType: fileType });
		return axios.get(urls.userDocumentUrl(userId, fileType, path), { responseType: "arraybuffer" })
			.then((response) => {
				var file = new Blob([response.data], { type: response.headers["content-type"] });
				var fileurl = window.URL.createObjectURL(file);
				window.open(fileurl);
				dispatch({
					type: ActionTypes.DOWNLOAD_DOCUMENT_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DOWNLOAD_DOCUMENT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function deleteDocument(userId, fileName, path) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_DOCUMENT_REQUEST, fileType: fileName });
		return axios.delete(urls.userDocumentUrl(userId, fileName, path))
			.then(() => {
				dispatch({
					type: ActionTypes.DELETE_DOCUMENT_SUCCESS,
					fileType: fileName
				});
				return fileName;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_DOCUMENT_FAILURE,
					error: error.response,
					fileType: fileName
				});
				throw error;
			});
	};
}

export function updateDocumentDescription(userId, fileName, path, description) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_DOCUMENT_REQUEST, fileType: fileName });
		return axios.patch(urls.userDocumentUrl(userId, fileName, path), {description})
			.then(() => {
				dispatch({
					type: ActionTypes.DELETE_DOCUMENT_SUCCESS,
					fileType: fileName
				});
				return fileName;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_DOCUMENT_FAILURE,
					error: error.response,
					fileType: fileName
				});
				throw error;
			});
	};
}
//#endregion

//#region Message
export function updateUserMessage(message) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_MESSAGE_REQUEST });
		return axios.put(urls.userMessageUrl(), { message })
			.then(() => {
				dispatch({
					type: ActionTypes.UPDATE_MESSAGE_SUCCESS,
					message: message
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_MESSAGE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserMessage() {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_MESSAGE_REQUEST });
		return axios.get(urls.userMessageUrl())
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_MESSAGE_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_MESSAGE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}
//#endregion

//#region ProfilePicture
export function getProfilePicture(userId, profilePictureName) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.GET_PROFILEPIC_REQUEST });
		return axios.get(urls.userDocumentUrl(userId, profilePictureName), { responseType: "arraybuffer" })
			.then((response) => {
				dispatch({
					type: ActionTypes.GET_PROFILEPIC_SUCCESS,
					data: `data:${response.headers['content-type']};base64,${new Buffer(response.data).toString('base64')}`
				});
			})
			.catch((error) => {
				if (error.response !== undefined) {
					if (error.response.status === 401) {
						window.location = getAuthenticationUrl();
						return;
					}
					if (error.response.status === 404) {
						return;
					}
				}

				dispatch({
					type: ActionTypes.GET_PROFILEPIC_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function deleteProfilePicture(userId, pictureName) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_PROFILEPIC_REQUEST });
		return axios.delete(urls.userDocumentUrl(userId, pictureName))
			.then(() => {
				dispatch({
					type: ActionTypes.DELETE_PROFILEPIC_SUCCESS
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_PROFILEPIC_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}


export function getProfileFiles(userId) {
	return new Promise((resolve, reject) => {

		axios.get(urls.userDocumentsUrl(userId))
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error.statusText);
			});

	});



}


const toBase64 = file => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = () => resolve(reader.result);
	reader.onerror = error => reject(error);
});

export function uploadProfilePicture(userId, document) {
	let data = new FormData();
	const config = {
		headers: { 'content-type': 'multipart/form-data' },
		credential: 'include'
	};
	data.append("file", document, document.name);
	let toReturnBase64 = '';
	let readDoc = async () => {
		toReturnBase64 = await toBase64(document);
	};
	readDoc();
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPLOAD_PROFILEPIC_REQUEST, documentName: document.name, fileType: FileTypes.ProfilePicture });
		return axios.post(urls.userDocumentUrl(userId, FileTypes.ProfilePicture), data, config)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPLOAD_PROFILEPIC_SUCCESS,
					data: toReturnBase64
				});
				return response;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPLOAD_PROFILEPIC_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}
//#endregion

export function resetUser() { return (dispatch) => { dispatch({ type: ActionTypes.RESET_USER_STATE }); }; };

export function setComplete(user) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.SET_COMPLETE_REQUEST, user: user.id });
		return axios.put(urls.completeById(user.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.SET_COMPLETE_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.SET_COMPLETE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function addPaymentMethod(user, paymentMethodId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_PAYMENTMETHOD_REQUEST, user: user.id, paymentMethod: paymentMethodId });
		return axios.post(urls.addPaymentMethodUrl(user.id), { paymentMethodId: paymentMethodId })
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_PAYMENTMETHOD_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_PAYMENTMETHOD_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function removePaymentMethod(user, paymentMethod) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.REMOVE_PAYMENTMETHOD_REQUEST, user: user.id, paymentMethod: paymentMethod });
		return axios.delete(urls.removePaymentMethodUrl(user.id, paymentMethod.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.REMOVE_PAYMENTMETHOD_SUCCESS,
					paymentMethod: paymentMethod
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.REMOVE_PAYMENTMETHOD_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getSetupIntent(user) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.GET_SETUPINTENT_REQUEST });
		return axios.get(urls.getSetupIntentByIdUrl(user.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.GET_SETUPINTENT_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.GET_SETUPINTENT_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getCurrentPrices(userId) {
	return axios.get(urls.getCurrentPricesUrl(userId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error.statusText;
		});
}

export function processPayment(user, discountCode, setupFeeInstallments) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.PROCESS_PAYMENT_REQUEST, });
		return axios.post(urls.processPaymentdUrl(user.id), { discountCode: discountCode, setupFeeInstallments: setupFeeInstallments })
			.then((response) => {
				dispatch({
					type: ActionTypes.PROCESS_PAYMENT_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.PROCESS_PAYMENT_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function validateDiscountCode(user, discountCode) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.PROCESS_PAYMENT_REQUEST, });
		return axios.post(urls.processPaymentdUrl(user.id), { discountCode: discountCode })
			.then((response) => {
				dispatch({
					type: ActionTypes.PROCESS_PAYMENT_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.PROCESS_PAYMENT_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getBillingCustomerId(userId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.GET_BILLINGCUSTOMERID_REQUEST });
		return axios.get(urls.userBillingCustomerIdByIdUrl(userId))
			.then((response) => {
				dispatch({
					type: ActionTypes.GET_BILLINGCUSTOMERID_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.GET_BILLINGCUSTOMERID_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

//#region invoices
export function fetchInvoices() {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_INVOICES_REQUEST, });
		return axios.get(urls.getInvoicesUrl())
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_INVOICES_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_INVOICES_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}
//#endregion

export function fetchPartnerCustomization(partnerId) {
	return axios.get(urls.getPartnerCustomizationUrl(partnerId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error.statusText;
		});
}


//#region Change PhoneNumber

export function changePhoneNumberSecurity(phoneNumber, userId) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.SEND_OTP_CODE_REQUEST, phoneNumber: phoneNumber });
		return axios.post(urls.changePhoneNumberUrl(userId), { newPhoneNumber: phoneNumber })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.SEND_OTP_CODE_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.SEND_OTP_CODE_FAILURE,
					reason: error.response.status
				});
				if (error.response.status === 409)
					throw new Error("AlreadyExistingPhoneNumber");
			});
	};
}

export function updateUserSecurityInfo(phoneNumber, otpCode, userId) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.VERIFY_OTP_REQUEST, phoneNumber: phoneNumber, otpCode: otpCode });
		return axios.put(urls.userSecurityByIdUrl(userId), { id: userId, oTPCode: otpCode, newPhoneNumber: phoneNumber })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.VERIFY_OTP_SUCCESS,
					data: response.data,
					phoneNumber: phoneNumber
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.VERIFY_OTP_FAILURE,
					response: error.response
				});
				if (error.response.status === 400 && error.response.data.errors?.hasOwnProperty("otpCode")) {
					throw new Error("InvalidOtpCode");
				}
				throw error.statusText;
			});
	};
}

export function updateUserEmailAndPassword(email, password, newPassword, userId) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.SET_NEWPASSWORD_REQUEST });
		return axios.put(urls.userSecurityByIdUrl(userId), { id: userId, newEmail: email, currentPassword: password, newPassword: newPassword })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.SET_NEWPASSWORD_SUCCESS,
					email: email,
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.SET_NEWPASSWORD_FAILURE,
					response: error.response
				});
				if (error.response.status === 401) {
					throw "InvalidPassword";
				}
				throw error.statusText;
			});
	};
}
//#endregion


export function GetPaymentIntentsSecretKey(userId, secret) {
	return axios.get(urls.addPaymentMethodIntents(userId, secret))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error.statusText;
		});
}